export const round2DecimalPlaces = (num: number) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const round1DecimalPlace = (num: number) => {
  return Math.round((num + Number.EPSILON) * 10) / 10;
};

/**
 * get number of digits after decimal
 */
export const getDecimalPlaces = function(num: number){

  const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) { return 0; }
  return Math.max(
      0,
      // Number of digits right of decimal point.
      (match[1] ? match[1].length : 0)
      // Adjust for scientific notation.
      - (match[2] ? +match[2] : 0));
};

// eslint-disable-next-line
export const isNumber = (value: any) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

export const mod = (n: number, m: number) => {
  return ((n % m) + m) % m;
};